import { useState } from 'react';
import { faqs } from '@/mocks/yokaiManga';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-paper-50 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mb-10 text-center">
          <p className="text-sm font-medium text-primary-600">使用答疑</p>
          <h2 className="mt-1 font-serif text-2xl font-bold text-ink-900 md:text-3xl">常见问题</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-ink-500 md:text-base">
            关于在线观看、合集全集、更新频率与移动端体验，这里都有答案。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className="overflow-hidden rounded-2xl border border-paper-200 bg-paper-50 transition-colors"
              >
                <button
                  type="button"
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left md:px-6"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                >
                  <h3 className="font-serif text-base font-semibold text-ink-900 md:text-lg">{faq.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-50 text-primary-600 transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-add-line" aria-hidden="true"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-7 text-ink-600 md:px-6">{faq.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}